module.exports = __webpack_public_path__ + "static/img/Visualization23.9dca3aaa.png";